export const reorder = (list, startIndex, endIndex) => {
    if (!list.length) {
        return list;
    }
    if (startIndex < 0) {
        throw new Error('Start index is lower than 0.');
    }
    if (endIndex < 0) {
        throw new Error('End index is lower than 0.');
    }
    if (startIndex >= list.length) {
        throw new Error("Start index exceeds the array's length");
    }
    if (endIndex >= list.length) {
        throw new Error("End index exceeds the array's length");
    }
    const result = [...list];
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
//# sourceMappingURL=ColumnSelectorCard.utils.js.map